import React from 'react';
import { EmailBlock, DividerBlockContent } from '../types';

interface DividerBlockProps {
  block: EmailBlock;
  isSelected: boolean;
  onSelect: () => void;
  isDarkMode: boolean;
}

export const DividerBlock: React.FC<DividerBlockProps> = ({
  block,
  isSelected,
  onSelect,
  isDarkMode
}) => {
  const content = block.content as DividerBlockContent;

  const containerStyle: React.CSSProperties = {
    padding: content.spacing || '20px 0',
    textAlign: content.align || 'center',
    ...block.styles
  };

  const dividerStyle: React.CSSProperties = {
    borderTop: `${content.thickness || 1}px ${content.style || 'solid'} ${content.color || '#e5e7eb'}`,
    width: content.width || '100%',
    margin: '0 auto',
    borderLeft: 'none',
    borderRight: 'none',
    borderBottom: 'none'
  };

  return (
    <div style={containerStyle}>
      <div style={dividerStyle} />
    </div>
  );
};
